import React, { useState, useEffect } from "react";
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaLock,
  FaCommentDots,
  FaBirthdayCake,
  FaTransgender,
  FaGlobe,
  FaEdit,
  FaSave,
  FaTimes,
} from "react-icons/fa";
import Navbar from "./Navbar";
import Fotter from "./Fotter";
import { BASE_URL } from "../backend/backend.js"; 

const UserProfile = () => {
  const [profileData, setProfileData] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [editedValue, setEditedValue] = useState("");
  const [selectedPerson, setSelectedPerson] = useState("self");
  const [healthDetails, setHealthDetails] = useState([]);
  const [medicineData, setMedicineData] = useState([]);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [profilePicUrl, setProfilePicUrl] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        // UPDATED: Replaced hardcoded URL with BASE_URL
        const response = await fetch(`${BASE_URL}/user/loggeduser`, {
          credentials: "include",
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setUserData(data);
        setLoading(false);
        setError(null);
        setProfileData([
          { label: "Username", value: data.username, icon: <FaUser /> },
          { label: "Email", value: data.email, icon: <FaEnvelope /> },
          { label: "Mobile Number", value: data.mobileNumber, icon: <FaPhone /> },
        ]);
        setHealthDetails([
          { label: "Account Status", value: data.enabled ? "Active" : "Inactive", icon: <FaUser /> },
        ]);
        setMedicineData([
          { name: "Sample Medicine 1", time: "10:00 AM" },
          { name: "Sample Medicine 2", time: "2:00 PM" },
        ]);

        if (data && data.profilePicture) {
          setProfilePicUrl(data.profilePicture);
        }
      } catch (e) {
        setError(e.message);
        setLoading(false);
        console.error("Could not fetch user data:", e);
      }
    };

    fetchUserData();
  }, []);

  const handleEdit = (index, value) => {
    setEditIndex(index);
    setEditedValue(value);
  };

  const handleSave = (index) => {
    const updatedData = [...profileData];
    updatedData[index].value = editedValue;
    setProfileData(updatedData);
    setEditIndex(null);
    setEditedValue("");
  };

  const handleCancel = () => {
    setEditIndex(null);
    setEditedValue("");
  };

  if (loading) {
    return <div>Loading user data...</div>;
  }

  if (error) {
    return <div>Error fetching user data: {error}</div>;
  }

  if (!userData) {
    return <div>No user data available.</div>;
  }

  return (
    <>
      <Navbar />
      <br /><br /><br /><br /><br /><br />
      <div style={{ padding: "20px 10px" }}>
        <div style={{
          maxWidth: "900px",
          margin: "40px auto",
          padding: "30px",
          background: "#f5f5f5",
          borderRadius: "20px",
          boxShadow: "0 10px 20px rgba(0,0,0,0.1)"
        }}>
          {/* Header */}
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "30px" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              {profilePicUrl ? ( 
                <img
                  src={profilePicUrl}
                  alt="Profile"
                  style={{ borderRadius: "50%", width: "100px", height: "100px", objectFit: "cover" }}
                />
              ) : (
                <div style={{
                  width: "100px", height: "100px", borderRadius: "50%",
                  backgroundColor: "#e0f2f1", display: "flex",
                  alignItems: "center", justifyContent: "center", fontSize: "40px", color: "#00796b"
                }}>
                  <FaUser />
                </div>
              )}
              <div style={{ marginLeft: "20px" }}>
                <h2 style={{ color: "#00796b", fontFamily: "Poppins" }}>{userData.username}</h2>
                <p style={{ color: "#555" }}>{userData.roles.map(role => role.name).join(", ")}</p>
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
              {healthDetails.map((item, idx) => (
                <div key={idx} style={{
                  background: "#fff", borderRadius: "10px",
                  padding: "10px 15px", display: "flex",
                  alignItems: "center", gap: "10px", fontSize: "14px", color: "#555"
                }}>
                  <span style={{ fontSize: "20px", color: "#00796b" }}>{item.icon}</span>
                  <div>
                    <div style={{ fontWeight: "bold", color: "#000" }}>{item.value}</div>
                    <div>{item.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Profile Data */}
          {profileData.map((item, idx) => (
            <div key={idx} style={{
              background: "#fff", borderRadius: "10px",
              padding: "15px 20px", marginBottom: "15px",
              boxShadow: "0 5px 10px rgba(0,0,0,0.05)", display: "flex",
              justifyContent: "space-between", alignItems: "center"
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <span style={{ fontSize: "20px", color: "#00796b" }}>{item.icon}</span>
                <div>
                  <div style={{ fontSize: "14px", color: "#888" }}>{item.label}</div>
                  {editIndex === idx ? (
                    <input
                      type={item.isPassword ? "password" : "text"}
                      value={editedValue}
                      onChange={(e) => setEditedValue(e.target.value)}
                      style={{
                        fontSize: "16px", padding: "6px", border: "1px solid #ccc",
                        borderRadius: "6px", marginTop: "5px"
                      }}
                    />
                  ) : (
                    <div style={{ fontWeight: "bold", fontSize: "15px", color: "#222" }}>{item.value}</div>
                  )}
                </div>
              </div>
              {editIndex === idx ? (
                <div style={{ display: "flex", gap: "10px" }}>
                  <button onClick={() => handleSave(idx)} style={btnStyle}><FaSave /> Save</button>
                  <button onClick={handleCancel} style={cancelBtnStyle}><FaTimes /> Cancel</button>
                </div>
              ) : (
                item.label !== "Username" && 
                <button onClick={() => handleEdit(idx, item.value)} style={btnStyle}>
                  <FaEdit style={{ marginRight: "5px" }} /> Edit
                </button>
              )}
            </div>
          ))}

          {/* Medicine Section */}
          <div style={{ marginTop: "30px" }}>
            <h3 style={{ textAlign: "center", fontFamily: "Poppins", color: "#00796b", marginBottom: "20px" }}>
              💊 Medicine Tracking
            </h3>
            <div style={{ display: "flex", justifyContent: "center", marginBottom: "15px" }}>
              <select
                value={selectedPerson}
                onChange={(e) => setSelectedPerson(e.target.value)}
                style={{
                  padding: "8px 15px", borderRadius: "8px",
                  fontSize: "16px", border: "1px solid #ccc", background: "#fff"
                }}
              >
                <option value="self">For Yourself</option>
                <option value="family">For Family</option>
                <option value="friend">For Friend</option>
                <option value="other">For Other</option>
              </select>
            </div>

            <div style={{
              background: "#fff", borderRadius: "10px", padding: "15px 20px",
              boxShadow: "0 5px 10px rgba(0,0,0,0.05)"
            }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={thStyle}>Medicine</th>
                    <th style={thStyle}>Time</th>
                  </tr>
                </thead>
                <tbody>
                  {medicineData.map((medicine, idx) => (
                    <tr key={idx} style={{ borderBottom: "1px solid #ddd" }}>
                      <td style={tdStyle}>{medicine.name}</td>
                      <td style={tdStyle}>{medicine.time}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Fotter />
    </>
  );
};

const btnStyle = {
  background: "#00796b",
  color: "#fff",
  border: "none",
  padding: "6px 12px",
  borderRadius: "6px",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  fontSize: "14px"
};

const cancelBtnStyle = {
  ...btnStyle,
  background: "#aaa"
};

const thStyle = {
  textAlign: "left",
  padding: "10px",
  backgroundColor: "#00796b",
  color: "#fff"
};

const tdStyle = {
  padding: "10px",
  fontSize: "14px"
};

export default UserProfile;